import React from 'react'
import i18n from 'i18next';
import SingleRangeSlider from "./singleRangeSlider/SingleRangeSlider";
import {PopupForm} from "./MailRequest";
import {BsCheck2Square, BsSearch} from "react-icons/bs";
import {LuMicroscope} from "react-icons/lu";



class BiobankInput extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            collection_input: '',
            collection: [],
            collection_checked: [],
            type_input: '',
            type: [],
            type_checked: [],
            use_k_input: '',
            use_k: ['k_phenos',],
            use_k_checked: [true],
            k_phenos_input: 5,
            k_phenos_min: 0,
            k_phenos_max: 20,
            use_similarity_input: '',
            use_similarity: ['similarity',],
            use_similarity_checked: [false],
            similarity_input: 95,
            similarity_min: 80,
            similarity_max: 100,
            age_settings_input: '',
            age_settings: [],
            age_settings_checked: [],
            changing_prop_names: ['collection', 'type', 'use_k', 'use_similarity'],
            changing_prop_names_unchecked: [],
            changing_prop_checked_names: ['collection_checked', 'type_checked', 'use_k_checked', 'use_similarity_checked'],
            query: {}
        }
    }

    receiver_props = (nextProps, cur_prop_name, cur_prop_checked_name) => {
        let next_prop = this.state[cur_prop_name]
        let next_prop_checked = this.state[cur_prop_checked_name]
        if (typeof nextProps[cur_prop_name] !== 'undefined' && typeof nextProps[cur_prop_checked_name] !== 'undefined') {
            let flag = true;
            if (nextProps[cur_prop_name].length === this.state[cur_prop_name].length) {
                flag = false;
                for (const i in nextProps[cur_prop_name]) {
                    if (nextProps[cur_prop_name][i] !== this.state[cur_prop_name][i]) {
                        flag = true
                        break;
                    }
                }
            }
            if (flag) {
                next_prop = nextProps[cur_prop_name]
                next_prop_checked = nextProps[cur_prop_checked_name]
            }
        }
        return [next_prop, next_prop_checked]
    }

    receiver_props_unchecked = (nextProps, cur_prop_name) => {
        let next_prop = this.state[cur_prop_name]
        if (typeof nextProps[cur_prop_name] !== 'undefined') {
            next_prop = nextProps[cur_prop_name]
        }
        return next_prop;
    }

    componentWillReceiveProps(nextProps, nextContext) {
        for (const i in this.state.changing_prop_names) {
            const next_props = this.receiver_props(nextProps, this.state.changing_prop_names[i], this.state.changing_prop_checked_names[i])
            this.setState({
                [this.state.changing_prop_names[i]]: next_props[0],
                [this.state.changing_prop_checked_names[i]]: next_props[1]
            });
        }
        for (const i in this.state.changing_prop_names_unchecked) {
            this.setState({
                [this.state.changing_prop_names_unchecked[i]]: this.receiver_props_unchecked(nextProps, this.state.changing_prop_names_unchecked[i]),
            });
        }
    }

    handleInput = (event) => {
        event.persist()
        this.setState({
            ...this.state,
            [event.target.name]: event.target.value
        });
    }

    handleCheck = (event) => {
        event.persist();
        let check_box_name = `${[event.target.name]}_checked`;
        let id = event.target.id;
        const checked = this.state[check_box_name];
        checked[id] = !checked[id];
        this.setState({
            ...this.state,
            [check_box_name]: checked,
        });
    }



    handleCheckK = (event) => {
        event.persist();
        let id = 0;
        // change K
        let check_box_k = `use_k_checked`;
        const checked_k = this.state[check_box_k];
        checked_k[id] = !checked_k[id];
        //change Similarity
        let check_box_sim = `use_similarity_checked`;
        const checked_sim = this.state[check_box_sim];
        checked_sim[id] = !checked_sim[id];
        this.setState({
            ...this.state,
            [check_box_k]: checked_k,
            [check_box_sim]: checked_sim,
        });
    }





    handleCheckAllButton = (event) => {
        event.persist();
        let check_box_name = `${[event.target.name]}_checked`;
        const checked = this.state[check_box_name];
        if (checked.length > 0) {
            let flag = false
            if (checked.reduce((sum, next) => sum + next) === 0) {
                flag = true
            }
            for (const id in checked) {
                checked[id] = flag
            }
            this.setState({
                ...this.state,
                [check_box_name]: checked,
            });
        }
    }

    handleChangeMaxK = (val) => {
        this.setState({
            ...this.state,
            "k_phenos_input": val
        });
    };
    handleChangeMaxSimilarity = (val) => {
        this.setState({
            ...this.state,
            "similarity_input": val
        });
    };


    handleNewRequest = (event) => {
        event.preventDefault();
        let prop_inputs = [];
        let state_prop_names = [];
        for (const i in this.state.changing_prop_names) {
            const prop_name = this.state.changing_prop_names[i]
            const prop_checked_name = this.state.changing_prop_checked_names[i]

            let prop_input = '';
            const prop_fields = this.state[prop_name];
            const prop_checks = this.state[prop_checked_name];

            for (const i in prop_checks) {
                if (prop_checks[i]) {
                    prop_input += prop_fields[i] + ",";
                }
            }
            prop_input = prop_input.slice(0, -1);
            const state_prop_name = `${prop_name}_input`
            prop_inputs.push(prop_input);
            state_prop_names.push(state_prop_name);
        }
        this.setState({
            ...this.state,
            [state_prop_names[0]]: prop_inputs[0],
            [state_prop_names[1]]: prop_inputs[1],
            [state_prop_names[2]]: prop_inputs[2],
            [state_prop_names[2]]: prop_inputs[3]
        });
        this.props.createNewRequest({
            ...this.state,
            [state_prop_names[0]]: prop_inputs[0],
            [state_prop_names[1]]: prop_inputs[1],
            [state_prop_names[2]]: prop_inputs[2],
            [state_prop_names[2]]: prop_inputs[3]
        });
    }

    render() {

        const htmls_collection = []
        for (const i in this.state.collection) {
            const id = `collection_${this.state.collection[i]}`
            htmls_collection.push(
                <div className="form-check">
                    <label className="form-check-label" htmlFor={id}>
                        <input type="checkbox"
                               className="form-check-input"
                               id={i}
                               name="collection"
                               value={this.state.collection[i]}
                               checked={this.state.collection_checked[i]}
                               onClick={this.handleCheck}/>
                        {i18n.t(id)}
                    </label>
                </div>
            )
        }

        const htmls_type = []
        for (const i in this.state.type) {
            const id = `type_${this.state.type[i]}`
            htmls_type.push(
                <div className="form-check">
                    <label className="form-check-label" htmlFor={id}>
                        <input type="checkbox"
                               className="form-check-input"
                               id={i}
                               name="type"
                               value={this.state.type[i]}
                               checked={this.state.type_checked[i]}
                               onClick={this.handleCheck}/>
                        {i18n.t(id)}
                    </label>
                </div>
            )
        }
        const htmls_use_k = []
        for (const i in this.state.use_k) {
            const id = `use_k_${this.state.use_k[i]}`
            htmls_use_k.push(
                <div className="form-check">
                    <label className="form-check-label" htmlFor={id}>
                        <input type="checkbox"
                               className="form-check-input"
                               id={i}
                               name="use_k"
                               value={this.state.use_k[i]}
                               checked={this.state.use_k_checked[i]}
                               onClick={this.handleCheckK}/>
                        {i18n.t(id)}
                    </label>
                </div>
            )
        }

        const htmls_use_similarity = []
        for (const i in this.state.use_similarity) {
            const id = `use_similarity_${this.state.use_similarity[i]}`
            htmls_use_similarity.push(
                <div className="form-check">
                    <label className="form-check-label" htmlFor={id}>
                        <input type="checkbox"
                               className="form-check-input"
                               id={i}
                               name="use_similarity"
                               value={this.state.use_similarity[i]}
                               checked={this.state.use_similarity_checked[i]}
                               onClick={this.handleCheckK}/>
                        {i18n.t(id)}
                    </label>
                </div>
            )
        }


        return (
            <form
                onSubmit={this.handleNewRequest}
                className="new-form">
                <h2>{i18n.t("top_filter_assays")}:</h2>

                <label>
                    {i18n.t("filter_collection")}:
                </label>
                {htmls_collection}
                <div className="text-end">
                    <button
                        title={i18n.t("reset_select_button")}
                        className="btn btn-outline-dark  w-25"
                        id="all_collection"
                        name="collection"
                        type="button"
                        onClick={this.handleCheckAllButton}>
                        <BsCheck2Square/>
                    </button>
                </div>
                <br/>

                <label>
                    {i18n.t("filter_type")}:
                </label>
                {htmls_type}
                <div className="text-end">
                    <button
                        title={i18n.t("reset_select_button")}
                        className="btn btn-outline-dark  w-25"
                        id="all_type"
                        name="type"
                        type="button"
                        onClick={this.handleCheckAllButton}>
                        <BsCheck2Square/>
                    </button>
                </div>
                <br/>




                <label>
                    {i18n.t("filter_use_k")}:
                </label>
                {htmls_use_k}
                <SingleRangeSlider
                    min={this.state.k_phenos_min}
                    max={this.state.k_phenos_max}
                    onChange={({min, max}) => console.log(`min = ${min}, max = ${max}`)}
                    changeMin={void(0)}
                    changeMax={this.handleChangeMaxK}
                    maxInit={this.state.k_phenos_input}
                />

                <label>
                    {i18n.t("filter_use_similarity")}:
                </label>
                {htmls_use_similarity}
                <SingleRangeSlider
                    min={this.state.similarity_min}
                    max={this.state.similarity_max}
                    onChange={({min, max}) => console.log(`min = ${min}, max = ${max}`)}
                    changeMin={void(0)}
                    changeMax={this.handleChangeMaxSimilarity}
                    maxInit={this.state.similarity_input}
                />


                <div className="row">
                    <div className="w-100">
                        <button
                            className="submit-input btn btn-outline-dark  w-100"
                            type="submit">
                            {i18n.t("request_button")}
                            &ensp;
                            <BsSearch/>
                        </button>
                    </div>
                </div>

            </form>
        )
    }
}

export {BiobankInput};
